export default "/_next/static/chunks/fonts/Zocial-5e415922d259313f2a42cb89f3aa8557.ttf";